import {
	EventIdentifier,
	type EventParams,
	isSegmentEventName,
	type SegmentServiceConfig,
	segmentWEBKey,
	Service,
	TrackingEventTypeWEB,
	TrackingService
} from '@capsicum/common';
import { AnalyticsBrowser } from '@segment/analytics-next';

import { isMarketingEnabled } from './utils';

export class SegmentTracking extends TrackingService<EventParams, SegmentServiceConfig> {
	protected segmentClient;

	protected override userId;

	public constructor(serviceConfig: SegmentServiceConfig, userId?: string) {
		super({
			serviceConfig
		});

		this.segmentClient = AnalyticsBrowser.load({
			writeKey: segmentWEBKey[serviceConfig as keyof typeof segmentWEBKey]
		});

		this.userId = userId;
	}

	public async setUserId(userId: string) {
		this.userId = userId;
	}

	public async sendEvent(eventType: TrackingEventTypeWEB, eventIdentifier: string, params?: EventParams) {
		if (!isMarketingEnabled() || !isSegmentEventName(eventIdentifier)) return;

		this.segmentClient[eventType](eventIdentifier, { ...params }, { userId: this.userId });
	}

	public getParams(params: EventParams) {
		return params;
	}

	public get serviceId() {
		return Service.SEGMENT;
	}

	setThirdPartySharing(isUserDataSharingAllowed: boolean, isRelevantAdsAllowed: boolean, isEea: boolean): void {
		void this.sendEvent(TrackingEventTypeWEB.track, EventIdentifier.GoogleUserConsent, {
			ads_storage_consent_state: isUserDataSharingAllowed,
			analytics_storage_consent_state: isRelevantAdsAllowed,
			is_user_from_eea: isEea
		});
	}
}
